import React, { useState } from 'react';
import { Box, Flex, Text, Button, HStack, Heading, IconButton } from '@chakra-ui/react';
import ChatBox from './ChatBox';
import { useAuth } from '../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ChatIcon } from '@chakra-ui/icons';

const AnythingChat = () => {
  const { currentUser } = useAuth();
  if (!currentUser) return null;
  const { targetUserId } = useParams();
  const navigate = useNavigate();
  const [isChatOpen, setIsChatOpen] = useState(true);
  const handleToggle = () => {
    setIsChatOpen(!isChatOpen);
  };
  return (
    <Flex
        direction="column"
        gap={4}
        p={4}
        w="400px"
        h="100vh"
    >
        <HStack>
            <Button onClick={() => navigate(-1)} colorScheme="gray" variant="outline">← 戻る</Button>
            <Heading>ご相談</Heading>
        </HStack>
       <Box 
            bg="gray.100"
            p={4}
            borderRadius="md"
            w="100%"
        >
            <Text>
                なんでもご気軽にご相談ください！
            </Text>
            <Text>
                ただし、間取りや設備の選択に関するご相談はそれぞれのページからのメッセージにてお願いします。
            </Text>
        </Box>
        <IconButton
            icon={<ChatIcon boxSize="30px" />}
            onClick={handleToggle}
            aria-label={isChatOpen ? "チャットを折りたたむ" : "チャットを展開する"}
            size="sm"
            variant="ghost"
            position="absolute"
            right={"30px"}
            top="30px"
            transform="translateY(-50%)"
            zIndex={20}
            bg="white"
            _hover={{ bg: "gray.100" }}
            boxShadow="sm"
          />
        <Box 
            w={isChatOpen ? "400px" : "0"}
            h={isChatOpen ? "100%" : "0"}
            position="absolute" // オーバーレイ表示のため absolute に変更
            top="0" // 親要素の上端に合わせる
            right="0" // 親要素の右端に合わせる
            transition="width 0.3s ease-in-out"
            overflowY="auto" // 内容が多い場合にスクロール可能にする
            zIndex={10} // 他の要素より手前に表示
            bg="white"
            borderWidth="1px"
          >
        <ChatBox itemType="anything" targetUserId={targetUserId} isOpen={isChatOpen} />
      </Box>
    </Flex>
  );
};

export default AnythingChat; 